<template>
  <div>
    <mais-indicadores-tabs :title="''" :cidadao="cidadao" />
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Exames',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
    cnsList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [utils],
  data() {
    return {}
  },
  mounted() {},
  computed: {},
  methods: {},
}
</script>

<style lang="scss"></style>
